<app-modal-dialog [configuration]="modalDialogConfiguration">
    <ng-container *ngIf="infotag">
        <div class="faq-item-container" *ngFor="let video of filteredVideos">
            <div class="faq-item-header pb-2">
                {{video.title}}
            </div>
            <div class="faq-item-body pb-3">

                <div class="row" *ngIf="video.thumbnail || video.videourl">
                    <div class="col-6">
                        {{video.description}}
                    </div>
                    <div class="col-6" fxLayoutAlign="end">
                        <div class="img-container" *ngIf="video.videourl; else thumbnail">
                            <img class="img-thumbnail" [src]="videoServerThumbnailUrl+video.thumbnail">
                            <fa-icon class="fa-play" icon="play" size="4x"></fa-icon>
                        </div>
                        <ng-template #thumbnail>
                            <div class="img-container" *ngIf=video.thumbnail>
                                <img class="img-thumbnail" [src]="videoServerThumbnailUrl+video.thumbnail">
                            </div>
                        </ng-template>
                    </div>
                </div>
                <div *ngIf="!video.thumbnail && !video.videourl">
                    {{video.description}}
                </div>

            </div>
        </div>
    </ng-container>
</app-modal-dialog>
